var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWakeUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#F98883"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 17.3636C11.8427 17.3636 10.7328 16.9039 9.91444 16.0856C9.0961 15.2672 8.63636 14.1573 8.63636 13C8.63636 11.8427 9.0961 10.7328 9.91444 9.91444C10.7328 9.0961 11.8427 8.63636 13 8.63636C14.1573 8.63636 15.2672 9.0961 16.0856 9.91444C16.9039 10.7328 17.3636 11.8427 17.3636 13C17.3636 14.1573 16.9039 15.2672 16.0856 16.0856C15.2672 16.9039 14.1573 17.3636 13 17.3636ZM12.2727 5H13.7273V7.18182H12.2727V5ZM12.2727 18.8182H13.7273V21H12.2727V18.8182ZM6.82909 7.85745L7.85745 6.82909L9.4 8.37164L8.37164 9.4L6.82909 7.85745ZM16.6 17.6284L17.6284 16.6L19.1709 18.1425L18.1425 19.1709L16.6 17.6284ZM18.1425 6.82836L19.1709 7.85745L17.6284 9.4L16.6 8.37164L18.1425 6.82909V6.82836ZM8.37164 16.6L9.4 17.6284L7.85745 19.1709L6.82909 18.1425L8.37164 16.6ZM21 12.2727V13.7273H18.8182V12.2727H21ZM7.18182 12.2727V13.7273H5V12.2727H7.18182Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWakeUp);
export default __webpack_public_path__ + "static/media/wake-up.81029033cb24fdc16ec2ec5b3234599e.svg";
export { ForwardRef as ReactComponent };